import { NotificationCard, NotificationCardProps } from '../../molecules'

export const NotificationCards = ({ cards }: { cards: NotificationCardProps[] }) => {
  return (
    <div className="fixed z-1000 right-8 top-8">
      {cards.map((card, index) => (
        <NotificationCard key={card.titleI18n + index} {...card} />
      ))}
    </div>
  )
}
